import { helpers, required } from '@vuelidate/validators'

export const serialnoValidator = {
  serialno: {
    required,
    validSerialnoSyntax: helpers.regex(/^[A-Z]{3,4}\d{9,10}$/)
  }
}
